import { createSlice } from '@reduxjs/toolkit';

export default createSlice({
  name: 'print',
  initialState: {
    innerPrinterConnected: false,
    externalPrinterConnected: false,
    externalPrinterStatus: null,
    externalPrinterReports: 0,
  },
  reducers: {
    setInnerPrinterConnected: (state, action) => {
      state.innerPrinterConnected = action.payload;
    },
    setExternalPrinterConnected: (state, action) => {
      state.externalPrinterConnected = action.payload;
    },
    setExternalPrinterStatus: (state, action) => {
      state.externalPrinterStatus = action.payload ?? null;
      state.externalPrinterReports += 1;
    },
  },
});

export const printProps = (state) => state;
